export default {
  paddingHorizontal: '16px',
  radius: {
    small: '3px',
    medium: '4px',
    large: '6px',
    // #72 (UI düzeltme demeti T6) — Button.js'in modern (T2/PeriodWizard'ın
    // PrimaryCta/SecondaryCta tarifinden genelleştirilen) köşe yarıçapı.
    // Ayrı bir token olarak eklendi (mevcut `large`/6px DEĞİŞTİRİLMEDİ —
    // kartlar/dropdown'lar gibi `large`'ı ZATEN kullanan onlarca yer var,
    // değerini değiştirmek onların görünümünü SESSİZCE bozardı).
    xl: '8px',
  },
  font: {
    family: "'Nunito Sans', sans-serif",
    size: {
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '20px',
      xl: '24px',
      xxl: '32px',
    },
    weight: {
      light: 300,
      regular: 400,
      semiBold: 600,
      bold: 700,
      extraBold: 800,
    },
  },
};
